import { atRoundEnd, defineGameCard } from '../authoring/index.js';
export const DataArchiveCard = defineGameCard({
    id: 'data_archive',
    gameplay: { type: 'STRUCTURE', cost: 3, baseStats: { attack: 0, health: 4 } },
    presentation: {
        name: 'Архив данных',
        description: 'В конце каждого раунда возьмите 1 дополнительную карту.',
        glyph: {
            colors: ['#10213A', '#6F6C70', '#494F5F', '#2B4659', '#70A4AD'],
            rows: [
                '......11111111......',
                '.....1222222221.....',
                '....122222222221....',
                '....123333333341....',
                '....123332233341....',
                '....123333333341....',
                '....121111111141....',
                '....121555555141....',
                '....121111111141....',
                '....121555555141....',
                '....121555555141....',
                '....121111111141....',
                '....121555555141....',
                '....121111111141....',
                '....123333333341....',
                '....123333333441....',
                '....123333344441....',
                '....123344444441....',
                '.....1111111111.....',
                '....................',
            ],
        },
    },
    role: 'playable',
    abilities: [
        atRoundEnd((ctx) => {
            if (ctx.self !== undefined)
                ctx.ops.drawCard(ctx.self.controllerId, 1);
        }),
    ],
});
//# sourceMappingURL=data_archive.js.map